module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Global-Landing-Page-w720.b8730a33.jpg";